import React from 'react';
import PropTypes from 'prop-types';
import TableHeader from '../TableHeader/TableHeader';
import DynamicListTableNew from '../DynamicListTableNew';
import FilterForm from '../FilterForm';

export default function ObjectTable({headerProps, filterProps, tableProps}) {
	return (
		<div className='object-table-container p-e h-100'>
			<TableHeader
				buttons={headerProps.buttons}
				icon={headerProps.icon}
				title={headerProps.title}
				filterOptions={headerProps.filterOptions}
				selectedFilterOption={headerProps.selectedFilterOption}
				onChangeFilter={headerProps.onChangeFilter}
				openFilterHandler={headerProps.openFilterHandler}
				getFilterUrl={headerProps.getFilterUrl}
				navigate={headerProps.navigate}
			/>
			<FilterForm
				filterOptions={filterProps.filterOptions}
				isOpen={filterProps.isOpen}
				handleDropdownToggle={filterProps.handleDropdownToggle}
				handleInputChange={filterProps.handleInputChange}
				clearFilter={filterProps.clearFilter}
				handleApplyFilter={filterProps.handleApplyFilter}
			/>
			<DynamicListTableNew
				className='mt-3'
				data={tableProps.data}
				loading={tableProps.loading}
				error={tableProps.error}
				count={tableProps.count}
				onPageChange={tableProps.onPageChange}
				page={parseInt(tableProps.page)}
				pageSize={tableProps.pageSize}
				handleSort={tableProps.handleSort}
				sortColumn={tableProps.sortColumn}
				direction={tableProps.direction}
				actionButtons={tableProps.actionButtons}
				columnInfo={tableProps.columnInfo}
				dataName={tableProps.dataName}
				showCheckboxColumn={tableProps.showCheckboxColumn}
			/>
		</div>
	);
}

ObjectTable.propTypes = {
	headerProps: PropTypes.shape({
		buttons: PropTypes.array.isRequired,
		icon: PropTypes.element.isRequired,
		title: PropTypes.string.isRequired,
		filterOptions: PropTypes.array.isRequired,
		selectedFilterOption: PropTypes.string,
		onChangeFilter: PropTypes.func.isRequired,
		openFilterHandler: PropTypes.func.isRequired,
		getFilterUrl: PropTypes.func.isRequired,
		navigate: PropTypes.func.isRequired
	}).isRequired,
	filterProps: PropTypes.shape({
		filterOptions: PropTypes.object.isRequired,
		isOpen: PropTypes.bool.isRequired,
		handleDropdownToggle: PropTypes.func.isRequired,
		handleInputChange: PropTypes.func.isRequired,
		clearFilter: PropTypes.func.isRequired,
		handleApplyFilter: PropTypes.func.isRequired
	}).isRequired,
	tableProps: PropTypes.shape({
		data: PropTypes.array.isRequired,
		loading: PropTypes.bool.isRequired,
		error: PropTypes.any,
		count: PropTypes.number.isRequired,
		onPageChange: PropTypes.func.isRequired,
		page: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
		pageSize: PropTypes.number.isRequired,
		handleSort: PropTypes.func.isRequired,
		sortColumn: PropTypes.string,
		direction: PropTypes.string,
		actionButtons: PropTypes.object.isRequired,
		columnInfo: PropTypes.array.isRequired,
		dataName: PropTypes.string.isRequired,
		showCheckboxColumn: PropTypes.bool
	}).isRequired
};
